// extracted by mini-css-extract-plugin
export var button = "_1p-1";
export var featuredLink = "_1p-4";
export var spinner = "_1p-2";
export var spinnerContainer = "_1p-3";
export var text = "_1p-0";